import { store } from 'react-notifications-component';

// Static Vars
export const API_URL = 'https://api.gotlocked.com/';
export const API_URL_DEV = 'http://localhost:3000/';

//Actions
export const GET_CARLIST = 'get_carlist';
export const SET_PROFILE = 'set_profile';
export const SET_TOKEN = 'set_token';
export const SET_ACTIVE_JOB = 'set_active_job';
export const CREATE_ACCOUNT = 'create_account';
export const SET_BIDS = 'set_bids';
export const SET_BID = 'set_bid';
export const SEND_OTP = 'send_otp';
export const SET_FINISHED_JOB = 'finished_job';
export const SET_MESSAGES = 'set_messages';
export const SET_CHAT_MESSAGES = 'set_chat_messages';

export const getApiUrl = () => {
    if (typeof (process.env.REACT_APP_ENV) === "string" && process.env.REACT_APP_ENV === "dev") {
        return API_URL_DEV;
    }
    return API_URL;
}

const showError = (err) => {
    store.addNotification({
        title: 'Network failure',
        message: err.message,
        type: 'danger',
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
            duration: 5000,
            onScreen: true
        }
    });
}

export async function validateToken(token) {
    if (token) {
        try {
            const response = await fetch(getApiUrl() + 'users/validate', {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": token
                }
            });
            const resp = await response.text();
            return resp;
        } catch(err) {
            showError(err);
            return {}
        }
    }
};

export async function getPoints(lat, lng) {
    try {
        const response = await fetch(getApiUrl() + 'techs/getpoints?lat=' + lat + '&lng=' + lng, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        const json = await response.json();
        return json;
    } catch(err) {
        showError(err);
        return {}
    }
};

export const addRating = (rating_data) => {
    return (dispatch, getState) => {
        let state = getState();
        let data = JSON.stringify(rating_data);
        if (state.token) {
            fetch(getApiUrl() + 'rating/job', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                },
                body: data
            }).then(response => response.json()).then(data => {}).catch(err => {
                showError(err);
            });
        }
    };
};

export const addChatMessage = (jobid, type, message_data) => {
    return (dispatch, getState) => {
        let state = getState();
        let data = JSON.stringify({
            jobid,
            type,
            data: message_data
        });
        if (state.token) {
            fetch(getApiUrl() + 'jobs/chat/message', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                },
                body: data
            })
                .then(response => response.json())
                .then(data => {
                    if (data.messages) {
                        dispatch({ type: SET_CHAT_MESSAGES, payload: data.messages });
                    }
                }).catch(err => {
                    showError(err);
                });
        }
    };
};

export const getChatMessages = (jobid) => {
    return (dispatch, getState) => {
        let state = getState();
        if (state.token && jobid) {
            try {
                fetch(getApiUrl() + 'jobs/chat/messages?jobid=' + jobid, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": state.token
                    }
                }).then(response => response.json()).then(data => {
                    try {
                        if (data.messages) {
                            dispatch({ type: SET_CHAT_MESSAGES, payload: data.messages });
                        }
                    } catch(err) {
                        showError(err);
                    }
                }).catch(err => {
                    showError(err);
                });
            } catch(err) {
                showError(err);
            }
        }
    };
};

export async function getChatMessagesAsync(token, jobid) {
    if (token && jobid) {
        try {
            const response = await fetch(getApiUrl() + 'jobs/chat/messages?jobid=' + jobid, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": token
                }
            });
            const json = await response.json();
            return json;
        } catch(err) {
            showError(err);
            return {}
        }
    }
};

export const addMessage = (jobid, type, message_data) => {
    return (dispatch, getState) => {
        let state = getState();
        let data = JSON.stringify({
            jobid,
            type,
            data: message_data
        });
        if (state.token) {
            fetch(getApiUrl() + 'jobs/message', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                },
                body: data
            })
                .then(response => response.json())
                .then(data => {
                    if (data.messages) {
                        dispatch({ type: SET_MESSAGES, payload: data.messages });
                    }
                }).catch(err => {
                    showError(err);
                });
        }
    };
};

export const getMessages = (jobid) => {
    return (dispatch, getState) => {
        let state = getState();
        if (state.token) {
            fetch(getApiUrl() + 'jobs/messages?jobid=' + jobid, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.messages) {
                        dispatch({ type: SET_MESSAGES, payload: data.messages });
                    }
                }).catch(err => {
                    showError(err);
                });
        }
    };
};

export async function getMessagesAsync(token, jobid) {
    if (token) {
        try {
            const response = await fetch(getApiUrl() + 'jobs/messages?jobid=' + jobid, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": token
                }
            });
            const json = await response.json();
            return json;
        } catch(err) {
            showError(err);
            return {}
        }
    }
};

export const acceptCost = (jobid) => {
    return (dispatch, getState) => {
        let state = getState();
        let data = JSON.stringify({
            jobid
        });
        if (state.token) {
            fetch(getApiUrl() + 'jobs/costs', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                },
                body: data
            })
                .then(response => response.json())
                .then(data => {
                    if (data.job) {
                        dispatch({ type: SET_ACTIVE_JOB, payload: data.job });
                    }
                }).catch(err => {
                    showError(err);
                });
        }
    };
};

export const updatePayment = (method, payment_data) => {
    return (dispatch, getState) => {
        let state = getState();
        let data = JSON.stringify({
            jobid: state.active_job.id,
            payment_method: method,
            payment_data: payment_data
        });
        if (state.token) {
            fetch(getApiUrl() + 'jobs/payment', {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                },
                body: data
            })
                .then(response => response.json())
                .then(data => {
                    if (data.job) {
                        dispatch({ type: SET_ACTIVE_JOB, payload: data.job });
                    }
                }).catch(err => {
                    showError(err);
                });
        }
    };
}

export const getWinningBid = (jobid) => {
    return (dispatch, getState) => {
        let state = getState();
        if (state.token) {
            fetch(getApiUrl() + 'bids/win?jobid=' + jobid, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.bids) {
                        dispatch({ type: SET_BID, payload: data.bids });
                    }
                }).catch(err => {
                    showError(err);
                });
        }
    };
};

export async function changeStatusAsync(token, jobid, status) {
    if (token) {
        let data = JSON.stringify({
            jobid,
            status
        });
        try {
            const response = await fetch(getApiUrl() + 'jobs/status', {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": token
                },
                body: data
            });
            const json = await response.json();
            return json;
        } catch(err) {
            showError(err);
            return {}
        }
    }
    return {};
};

export const changeStatus = (jobid, status) => {
    return (dispatch, getState) => {
        let state = getState();
        let data = JSON.stringify({
            jobid,
            status
        });
        if (state.token) {
            fetch(getApiUrl() + 'jobs/status', {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                },
                body: data
            })
                .then(response => response.json())
                .then(data => {
                    if (data.job) {
                        dispatch({ type: SET_ACTIVE_JOB, payload: data.job });
                    }
                }).catch(err => {
                    showError(err);
                });
        }
    };
};

export const rejectBid = (jobid, bidid) => {
    return (dispatch, getState) => {
        let state = getState();
        let data = JSON.stringify({
            jobid: jobid,
            bid: bidid
        });
        if (state.token) {
            fetch(getApiUrl() + 'bids/job', {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                },
                body: data
            })
                .then(response => response.json())
                .then(data => {
                    // if (data.bids) {
                    //     dispatch({ type: SET_BIDS, payload: data.bids });
                    // }
                }).catch(err => {
                    showError(err);
                });
        }
    };
};

export async function acceptBidAsync(token, jobid, bidid) {
    if (token) {
        let data = JSON.stringify({
            jobid: jobid,
            bid: bidid
        });
        try {
            const response = await fetch(getApiUrl() + 'bids/job', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": token
                },
                body: data
            });
            const json = await response.json();
            return json.bids;
        } catch(err) {
            showError(err);
            return {}
        }
    }
    return {};
}

export const acceptBid = (jobid, bidid) => {
    return (dispatch, getState) => {
        let state = getState();
        let data = JSON.stringify({
            jobid: jobid,
            bid: bidid
        });
        if (state.token) {
            fetch(getApiUrl() + 'bids/job', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                },
                body: data
            })
                .then(response => response.json())
                .then(data => {
                    if (data.bids) {
                        dispatch({ type: SET_BID, payload: data.bids });
                    }
                }).catch(err => {
                    showError(err);
                });
        }
    };
};

export async function getBidsAsync(token, jobid) {
    if (token) {
        try {
            const response = await fetch(getApiUrl() + 'bids/job?jobid=' + jobid, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": token
                },
            });
            const json = await response.json();
            return json.bids;
        } catch(err) {
            showError(err);
            return {};
        }
    }
    return {};
};

export const getBids = (jobid) => {
    return (dispatch, getState) => {
        let state = getState();
        if (state.token) {
            fetch(getApiUrl() + 'bids/job?jobid=' + jobid, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.bids) {
                        dispatch({ type: SET_BIDS, payload: data.bids });
                    }
                }).catch(err => {
                    showError(err);
                });
        }
    };
};

export const cancelJob = (jobid, reason) => {
    return (dispatch, getState) => {
        let state = getState();
        let data = JSON.stringify({
            jobid: jobid,
            reason: reason
        });
        if (state.token) {
            fetch(getApiUrl() + 'jobs/customer', {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                },
                body: data
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status) {
                        dispatch({ type: SET_ACTIVE_JOB, payload: null });
                    }
                }).catch(err => {
                    showError(err);
                });
        }
    };
};

export const createJob = (job) => {
    return (dispatch, getState) => {
        let state = getState();
        let image_upload = null;
        if (job.image) {
            image_upload = job.image;
            delete job.image;
        }
        if (state.token) {
            fetch(getApiUrl() + 'jobs/customer', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                },
                body: JSON.stringify(job),
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status) {
                        if (image_upload) {
                            dispatch(uploadJobFile(data.job.id, image_upload));
                        } else {
                            dispatch({ type: SET_ACTIVE_JOB, payload: data.job });
                        }
                    }
                }).catch(err => {
                    showError(err);
                });
        }
    };
};

export const uploadJobFile = (jobid, file) => {
    return (dispatch, getState) => {
        let state = getState();
        if (state.token != null) {
            fetch(getApiUrl() + 'jobs/upload64', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                },
                body: JSON.stringify({
                    jobid: jobid,
                    files: [file]
                }),
            })
                .then(response => response.json())
                .then(data => {
                    dispatch({ type: SET_ACTIVE_JOB, payload: data.job });
                }).catch(err => {
                    showError(err);
                });
        } else {
            console.log('uploadJobFile missing token');
        }
    };
}

export const createAccount = (data) => {
    return (dispatch, getState) => {
        let state = getState();
        if (state.token == "" || state.token == null) {
            fetch(getApiUrl() + 'users/register', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                },
                body: JSON.stringify({
                    email: data.email,
                    firstname: data.first_name,
                    lastname: data.last_name,
                    phonenumber: data.phonenumber,
                }),
            })
                .then(response => response.json())
                .then(json => {
                    if (json.status) {
                        sendOtp(json.phonenumber);
                    }
                }).catch(err => {
                    showError(err);
                });
        }
    };
};

export const getLastFinishedJob = () => {
    return (dispatch, getState) => {
        let state = getState();
        if (state.token) {
            fetch(getApiUrl() + 'jobs/done', {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                }
            })
                .then(response => response.json())
                .then(data => {
                    dispatch({ type: SET_FINISHED_JOB, payload: data.job });
                    return data;
                }).catch(err => {
                    showError(err);
                });
        }
    };
}

export const getActiveJob = () => {
    return (dispatch, getState) => {
        let state = getState();
        if (state.token) {
            fetch(getApiUrl() + 'jobs/active', {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": state.token
                }
            })
                .then(response => response.json())
                .then(data => {
                    dispatch({ type: SET_ACTIVE_JOB, payload: data.job });
                    return data;
                }).catch(err => {
                    showError(err);
                });
        }
    };
};

export async function getActiveJobAsync(token) {
    if (token) {
        try {
            const response = await fetch(getApiUrl() + 'jobs/active', {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": token
                }
            });
            const json = await response.json();
            return json;
        } catch(err) {
            showError(err);
            return {}
        }
    }
};

export async function sendOtpAsync(phonenumber) {
    let data = {
        phonenumber
    };
    try {
        const response = await fetch(getApiUrl() + 'users/resend', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        const json = await response.json();
        return json;
    } catch(err) {
        showError(err);
        return {}
    }
};

export const sendOtp = (phonenumber) => {
    return async (dispatch) => {
        let data = {
            phonenumber
        };
        fetch(getApiUrl() + 'users/resend', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status) {
                    dispatch({ type: SEND_OTP, payload: data });
                    return data;
                } else {
                    store.addNotification({
                        title: 'Account not found',
                        message: 'We cant find your account',
                        type: 'danger',
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });
                }
            }).catch(err => {
                showError(err);
            });
    };
};

export async function verifyOtpAsync(phonenumber, code) {
    let data = {
        phonenumber,
        code
    };
    try {
        const response = await fetch(getApiUrl() + 'users/verify', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        const json = await response.json();
        return json;
    } catch(err) {
        showError(err);
        return {}
    }
}

export const verifyOtp = (phonenumber, code) => {
    return (dispatch) => {
        let data = {
            phonenumber,
            code
        };
        fetch(getApiUrl() + 'users/verify', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then(response => response.json())
            .then(data => {
                dispatch({ type: SET_TOKEN, payload: data.token });
                dispatch({ type: SET_PROFILE, payload: data.user });
                return data;
            }).catch(err => {
                showError(err);
            });
    };
};

export const getProfileData = (token) => {
    return (dispatch) => {
        fetch(getApiUrl() + 'users/profile', {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token
            }
        })
            .then(response => response.json())
            .then(data => {

                dispatch({ type: SET_PROFILE, payload: data.profile });
                return data;
            }).catch(err => {
                showError(err);
            });
    };
};

export const getCarlist = () => {
    return (dispatch) => {
        fetch(getApiUrl() + 'cars/getList', {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                dispatch({ type: GET_CARLIST, payload: data });
                return data;
            }).catch(err => {
                showError(err);
            });
    };
};

export const getMakeModel = (key, val, make, model) => {
    return (dispatch) => {
        let objToSend = {
            query: key,
            value: val,
            model: model,
            make: make
        };
        fetch(getApiUrl() + 'general/cars', {
            method: "POST",
            body: JSON.stringify(objToSend),
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                dispatch({ type: GET_CARLIST, payload: data });
                return data;
            }).catch(err => {
                showError(err);
            });
    };
};
